module.exports = kolibriGlobal.coreVue.components.PermissionsIcon;